import React, { useEffect } from "react";
import { ProductInquiryTable } from "./product-inquiry-table";
import Filter from "./Filter";
import Loading from "../../../../components/ui/Loading/Loading";

const ProductInquiryBB = () => {
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("hospitalName");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (selectedFilter?.orderBy !== undefined) {
      setSortFilter({
        orderBy: selectedFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter?.orderBy]);

  return (
    <>
      {isResetting ? (
        <Loading />
      ) : (
        <>
          {isResetted ? (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
            />
          ) : (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
            />
          )}
        </>
      )}
      <ProductInquiryTable filter={isResetted ? resettedFilter : filters} />
    </>
  );
};

export default ProductInquiryBB;
